module.exports = __webpack_public_path__ + "img/red.e64f28ca.svg";